var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('form', {
    staticClass: "message-box",
    attrs: {
      "action": "#"
    },
    on: {
      "submit": function submit($event) {
        $event.preventDefault();
        return _vm.submitHandler.apply(null, arguments);
      }
    }
  }, [_c('div', {
    staticClass: "bd"
  }, [_c('input', {
    staticClass: "text-input",
    attrs: {
      "placeholder": _vm.$t('liveroom.messagebox')
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "input": _vm.textInputHandler
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "ft"
  }, [_c('button', {
    staticClass: "submit-button",
    on: {
      "click": _vm.submitHandler
    }
  }, [_vm._v(_vm._s(_vm.$t('liveroom.send')))])]), _vm._v(" "), _c('share-button', [_c('div', {
    class: _vm.share,
    on: {
      "click": _vm.shareHandler
    }
  })])], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };